import Austin from "../assets/images/texas-flag.svg";
import Other from "../assets/images/round-pushpin.png";

const Hyperlocal = [
  {
    id: 0,
    value: "austin",
    longValue: "Austin, Texas",
    backendValue: false,
    hasImage: true,
    image: Austin,
    hasOptions: false,
    hasLink: false,
  },
  {
    id: 1,
    value: "other",
    longValue: "Somewhere else",
    backendValue: false,
    hasImage: true,
    image: Other,
    hasOptions: false,
    hasLink: false,
    linkHref: "/hyperlocal-networks/other-city",
    linkText: "Select city",
  },
  //   data: [
  //     {
  //       id: 0,
  //       value: "Abilene",
  //       backendValue: "Abilene",
  //     },
  //     {
  //       id: 1,
  //       value: "Allen",
  //       backendValue: "Allen",
  //     },
  //     {
  //       id: 2,
  //       value: "Amarillo",
  //       backendValue: "Amarillo",
  //     },
  //     {
  //       id: 3,
  //       value: "Arlington",
  //       backendValue: "Arlington",
  //     },
  //     {
  //       id: 4,
  //       value: "Atascocita",
  //       backendValue: "Atascocita",
  //     },
  //     {
  //       id: 5,
  //       value: "Austin",
  //       backendValue: "Austin",
  //     },
  //     {
  //       id: 6,
  //       value: "Baytown",
  //       backendValue: "Baytown",
  //     },
  //     {
  //       id: 7,
  //       value: "Beaumont",
  //       backendValue: "Beaumont",
  //     },
  //     {
  //       id: 8,
  //       value: "Brownsville",
  //       backendValue: "Brownsville",
  //     },
  //     {
  //       id: 9,
  //       value: "Bryan",
  //       backendValue: "Bryan",
  //     },
  //     {
  //       id: 10,
  //       value: "Carrollton",
  //       backendValue: "Carrollton",
  //     },
  //     {
  //       id: 11,
  //       value: "Cedar Park",
  //       backendValue: "Cedar Park",
  //     },
  //     {
  //       id: 12,
  //       value: "College Station",
  //       backendValue: "College Station",
  //     },
  //     {
  //       id: 13,
  //       value: "Conroe",
  //       backendValue: "Conroe",
  //     },
  //     {
  //       id: 14,
  //       value: "Corpus Christi",
  //       backendValue: "Corpus Christi",
  //     },
  //     {
  //       id: 15,
  //       value: "Dallas",
  //       backendValue: "Dallas",
  //     },
  //     {
  //       id: 16,
  //       value: "Denton",
  //       backendValue: "Denton",
  //     },
  //     {
  //       id: 17,
  //       value: "DeSoto",
  //       backendValue: "DeSoto",
  //     },
  //     {
  //       id: 18,
  //       value: "Edinburg",
  //       backendValue: "Edinburg",
  //     },
  //     {
  //       id: 19,
  //       value: "El Paso",
  //       backendValue: "El Paso",
  //     },
  //     {
  //       id: 20,
  //       value: "Euless",
  //       backendValue: "Euless",
  //     },
  //     {
  //       id: 21,
  //       value: "Flower Mound",
  //       backendValue: "Flower Mound",
  //     },
  //     {
  //       id: 22,
  //       value: "Fort Worth",
  //       backendValue: "Fort Worth",
  //     },
  //     {
  //       id: 23,
  //       value: "Frisco",
  //       backendValue: "Frisco",
  //     },
  //     {
  //       id: 24,
  //       value: "Galveston",
  //       backendValue: "Galveston",
  //     },
  //     {
  //       id: 25,
  //       value: "Garland",
  //       backendValue: "Garland",
  //     },
  //     {
  //       id: 26,
  //       value: "Georgetown",
  //       backendValue: "Georgetown",
  //     },
  //     {
  //       id: 27,
  //       value: "Grand Prairie",
  //       backendValue: "Grand Prairie",
  //     },
  //     {
  //       id: 28,
  //       value: "Grapevine",
  //       backendValue: "Grapevine",
  //     },
  //     {
  //       id: 29,
  //       value: "Harlingen",
  //       backendValue: "Harlingen",
  //     },
  //     {
  //       id: 30,
  //       value: "Houston",
  //       backendValue: "Houston",
  //     },
  //     {
  //       id: 31,
  //       value: "Irving",
  //       backendValue: "Irving",
  //     },
  //     {
  //       id: 32,
  //       value: "Killeen",
  //       backendValue: "Killeen",
  //     },
  //     {
  //       id: 33,
  //       value: "Laredo",
  //       backendValue: "Laredo",
  //     },
  //     {
  //       id: 34,
  //       value: "League City",
  //       backendValue: "League City",
  //     },
  //     {
  //       id: 35,
  //       value: "Lewisville",
  //       backendValue: "Lewisville",
  //     },
  //     {
  //       id: 36,
  //       value: "Longview",
  //       backendValue: "Longview",
  //     },
  //     {
  //       id: 37,
  //       value: "Lubbock",
  //       backendValue: "Lubbock",
  //     },
  //     {
  //       id: 38,
  //       value: "Mansfield",
  //       backendValue: "Mansfield",
  //     },
  //     {
  //       id: 39,
  //       value: "McAllen",
  //       backendValue: "McAllen",
  //     },
  //     {
  //       id: 40,
  //       value: "McKinney",
  //       backendValue: "McKinney",
  //     },
  //     {
  //       id: 41,
  //       value: "Mesquite",
  //       backendValue: "Mesquite",
  //     },
  //     {
  //       id: 42,
  //       value: "Midland",
  //       backendValue: "Midland",
  //     },
  //     {
  //       id: 43,
  //       value: "Mission",
  //       backendValue: "Mission",
  //     },
  //     {
  //       id: 44,
  //       value: "Missouri City",
  //       backendValue: "Missouri City",
  //     },
  //     {
  //       id: 45,
  //       value: "New Braunfels",
  //       backendValue: "New Braunfels",
  //     },
  //     {
  //       id: 46,
  //       value: "North Richland Hills",
  //       backendValue: "North Richland Hills",
  //     },
  //     {
  //       id: 47,
  //       value: "Odessa",
  //       backendValue: "Odessa",
  //     },
  //     {
  //       id: 48,
  //       value: "Pasadena",
  //       backendValue: "Pasadena",
  //     },
  //     {
  //       id: 49,
  //       value: "Pearland",
  //       backendValue: "Pearland",
  //     },
  //     {
  //       id: 50,
  //       value: "Pflugerville",
  //       backendValue: "Pflugerville",
  //     },
  //     {
  //       id: 51,
  //       value: "Pharr",
  //       backendValue: "Pharr",
  //     },
  //     {
  //       id: 52,
  //       value: "Plano",
  //       backendValue: "Plano",
  //     },
  //     {
  //       id: 53,
  //       value: "Port Arthur",
  //       backendValue: "Port Arthur",
  //     },
  //     {
  //       id: 54,
  //       value: "Richardson",
  //       backendValue: "Richardson",
  //     },
  //     {
  //       id: 55,
  //       value: "Round Rock",
  //       backendValue: "Round Rock",
  //     },
  //     {
  //       id: 56,
  //       value: "Rowlett",
  //       backendValue: "Rowlett",
  //     },
  //     {
  //       id: 57,
  //       value: "San Angelo",
  //       backendValue: "San Angelo",
  //     },
  //     {
  //       id: 58,
  //       value: "San Antonio",
  //       backendValue: "San Antonio",
  //     },
  //     {
  //       id: 59,
  //       value: "San Marcos",
  //       backendValue: "San Marcos",
  //     },
  //     {
  //       id: 60,
  //       value: "Spring",
  //       backendValue: "Spring",
  //     },
  //     {
  //       id: 61,
  //       value: "Sugar Land",
  //       backendValue: "Sugar Land",
  //     },
  //     {
  //       id: 62,
  //       value: "Temple",
  //       backendValue: "Temple",
  //     },
  //     {
  //       id: 63,
  //       value: "The Woodlands",
  //       backendValue: "The Woodlands",
  //     },
  //     {
  //       id: 64,
  //       value: "Tyler",
  //       backendValue: "Tyler",
  //     },
  //     {
  //       id: 65,
  //       value: "Victoria",
  //       backendValue: "Victoria",
  //     },
  //     {
  //       id: 66,
  //       value: "Waco",
  //       backendValue: "Waco",
  //     },
  //     {
  //       id: 67,
  //       value: "Wichita Falls",
  //       backendValue: "Wichita Falls",
  //     },
  //   ],
  // },
];

export default Hyperlocal;
